<template>
  <div class="Fuell-Overlay">
    <div class="Fuell-Modal">
      <div
        class="Fuell-Modal--overlay"
        @click="closeModal"
      ></div>
      <div class="Fuell-Modal--window change-pass-modal centered">
        <button
          class="Fuell-Modal--close-button"
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt="close"
          >
        </button>

        <h3
          class="Fuell-Modal--title"
          v-t.preserve="{path: 'user_profile_change_password'}"
        ></h3>

        <div class="form-fields">
          <div class="input--block mb-3 col">
            <label
              class="form--label"
              v-t="{ path :'CURRENT_PASSWORD'}"
            ></label>
            <div
              class="Form-field"
              :class="{'Form--field-error': $v.currentPassword.$error}"
            >
              <input
                type="password"
                class="Input-text"
                v-model="currentPassword"
                maxlength="48"
                @blur="$v.currentPassword.$touch()"
              >
            </div>
          </div>

          <div class="input--block mb-3 col">
            <label
              class="form--label"
              v-t="{ path :'NEW_PASSWORD'}"
            ></label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : $v.newPassword.$error}"
            >
              <input
                type="password"
                class="Input-text"
                v-model="newPassword"
                maxlength="48"
                @blur="$v.newPassword.$touch()"
              >
            </div>
          </div>

          <div class="input--block mb-3 col">
            <label
              class="form--label"
              v-t="{ path :'REPEAT_NEW_PASSWORD'}"
            ></label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : !$v.repeatNewPassword.sameAsPassword}"
            >
              <input
                type="password"
                class="Input-text"
                v-model="repeatNewPassword"
                maxlength="48"
              >
            </div>
            <small v-if="!$v.repeatNewPassword.sameAsPassword">
              <p
                class="field-error-message"
                v-t="{path: 'validations_password_mismatch'}"
              ></p>
            </small>
          </div>
        </div>

        <div class="d-flex justify-content-center mb-1">
          <button
            @click="submit"
            class="Fuell-Button blue"
            :disabled="!canBeSubmitted"
          >
            <span class="Fuell-Button--label">{{ $t('login_reset_password_form_submit') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
const { validationMixin } = require('vuelidate')
const { required, sameAs } = require('vuelidate/lib/validators')
export default {
  name: 'UserProfileResetPasswordModal',
  mixins: [_modalHandlerMixin, validationMixin],
  data () {
    return {
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: ''
    }
  },
  methods: {
    async submit () {
      if (!this.canBeSubmitted) return
      await this.$store.dispatch('UsersStore/changeUserPassword', { id: this.loggedUserId, oldPassword: this.currentPassword, password: this.newPassword })
      this.closeModal()
    }
  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId'] ? this.$store.getters['LoginStore/loggedUserId'] : false
    }

  },
  validations: {
    currentPassword: { required },
    newPassword: { required },
    repeatNewPassword: { sameAsPassword: sameAs('newPassword') }
  }

}
</script>

<style scoped>
.change-pass-modal {
  max-width: 400px;
}
.form-fields {
  padding: 40px 0;
  margin: auto;
  max-width: 340px;
  width: 100%;
}
.form--label {
  text-transform: uppercase;
}
.field-error-message {
  color: var(--red);
  margin-top: -8px;
  font-size: 12px;
  font-weight: 300;
}
</style>
